/** Both dates are UTC-midnight calendar dates, so a later instant means a later day. */
export function isExpirationAfterIssued(issuedDate, expirationDate) {
    return expirationDate > issuedDate;
}
//# sourceMappingURL=is-expiration-after-issued.js.map